module.exports = __webpack_public_path__ + "static/media/score.0f0d3005.svg";